import ChooseEntityPage from "./ChooseEntity/ChooseEntityPage";

export default ChooseEntityPage;
